<template>
  <v-container style="background-color: #f5f6fa" fluid class="pa-4">

    <!-- ══════════════════════ VISTA LISTA ══════════════════════ -->
    <v-slide-x-transition>
      <div v-if="!show_details">

        <!-- Header banner -->
        <v-card class="mb-4 rounded-lg" style="background: linear-gradient(135deg, #1565C0 0%, #0288D1 100%); overflow:hidden;">
          <v-card-text class="py-5 px-6">
            <v-row align="center" no-gutters>
              <v-col cols="auto" class="mr-4">
                <v-avatar size="52" color="white" style="opacity:.15; position:absolute;"></v-avatar>
                <v-icon size="36" color="white">edit_calendar</v-icon>
              </v-col>
              <v-col>
                <div class="white--text text-h5 font-weight-bold">Cierre de Año Contable</div>
                <div class="white--text body-2" style="opacity:.8">Gestión y control de cierres de ejercicios fiscales</div>
              </v-col>
              <v-col cols="auto">
                <v-chip dark outlined class="mr-2">
                  <v-icon small left>business</v-icon>
                  {{ items_calendar.length }} años
                </v-chip>
                <v-chip dark color="white" class="primary--text font-weight-bold">
                  <v-icon small left color="primary">check_circle</v-icon>
                  {{ items_calendar.filter(i => !i.is_closed).length }} abiertos
                </v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Filtros + tabla -->
        <v-card class="rounded-lg" elevation="1">
          <v-card-text class="pa-0">
            <v-data-table
              dense
              :items-per-page="12"
              height="60vh"
              hide-default-footer
              :headers="headers"
              fixed-header
              :items="items_calendar"
              :search="search"
              :loading="loading"
              loading-text="Cargando años..."
              no-data-text="No hay años registrados"
            >
              <template v-slot:top>
                <v-toolbar flat class="rounded-t-lg">
                  <v-icon color="primary" class="mr-2">calendar_today</v-icon>
                  <v-toolbar-title class="font-weight-bold grey--text text--darken-2">Años fiscales</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar año..."
                    single-line dense hide-details outlined
                    style="max-width:220px"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-autocomplete
                    v-model="business_unit_id"
                    label="Unidad de negocio"
                    :items="$store.state.auth.bussines_units"
                    @change="get_years"
                    color="primary"
                    outlined dense hide-details
                    prepend-inner-icon="business"
                    style="max-width:260px"
                  ></v-autocomplete>
                </v-toolbar>
                <v-divider></v-divider>
              </template>

              <!-- Chip de estado -->
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  small
                  :color="item.is_closed ? 'red lighten-5' : 'green lighten-5'"
                  :text-color="item.is_closed ? 'red darken-2' : 'green darken-2'"
                  class="font-weight-bold"
                >
                  <v-icon x-small left :color="item.is_closed ? 'red darken-2' : 'green darken-2'">
                    {{ item.is_closed ? 'lock' : 'lock_open' }}
                  </v-icon>
                  {{ item.status }}
                </v-chip>
              </template>

              <!-- Acción ver -->
              <template v-slot:[`item.options`]="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small color="primary" v-on="on" @click="view_details(item)">
                      <v-icon small>arrow_forward</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver detalles</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-slide-x-transition>

    <!-- ══════════════════════ VISTA DETALLE ══════════════════════ -->
    <v-slide-x-transition>
      <div v-if="show_details">

        <!-- Barra de navegación -->
        <v-row align="center" no-gutters class="mb-4">
          <v-btn text small color="primary" @click="show_details=false" class="pl-0">
            <v-icon left>arrow_back</v-icon> Volver a la lista
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!year_selected?.is_closed"
            color="primary" depressed
            @click="show_dialog_confirm=true"
          >
            <v-icon left small>free_cancellation</v-icon> Cerrar año
          </v-btn>
          <v-btn
            v-else
            color="orange darken-2" dark depressed
            @click="show_dialog_reopen=true"
          >
            <v-icon left small>lock_open</v-icon> Reabrir año
          </v-btn>
        </v-row>

        <!-- Hero card del año -->
        <v-card
          class="rounded-lg mb-4"
          :style="`background: linear-gradient(135deg, ${year_selected?.is_closed ? '#B71C1C, #E53935' : '#1B5E20, #43A047'} ); overflow:hidden;`"
          elevation="2"
        >
          <v-card-text class="py-6 px-8">
            <v-row align="center" no-gutters>
              <v-col>
                <div class="white--text text-overline" style="opacity:.75; letter-spacing:2px">Año fiscal</div>
                <div class="white--text text-h3 font-weight-black">{{ year_selected?.calendar }}</div>
                <div class="white--text body-1 mt-1" style="opacity:.85">
                  <v-icon small color="white" class="mr-1">date_range</v-icon>
                  {{ year_selected?.date_from }} &nbsp;→&nbsp; {{ year_selected?.date_to }}
                </div>
              </v-col>
              <v-col cols="auto" class="text-center">
                <v-avatar size="80" :color="year_selected?.is_closed ? 'red darken-4' : 'green darken-4'" style="opacity:.35; position:absolute; transform:translate(-10px,-10px);"></v-avatar>
                <v-icon size="60" color="white" style="opacity:.9">
                  {{ year_selected?.is_closed ? 'lock' : 'lock_open' }}
                </v-icon>
                <div class="white--text font-weight-bold mt-1" style="letter-spacing:1px">
                  {{ year_selected?.is_closed ? 'CERRADO' : 'ACTIVO' }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Stats rápidas -->
        <v-row class="mb-4" no-gutters>
          <v-col cols="12" md="4" class="pr-md-2 pb-2 pb-md-0">
            <v-card class="rounded-lg pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar size="44" color="blue lighten-5" class="mr-3">
                  <v-icon color="blue darken-2">business</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Unidad de negocio</div>
                  <div class="body-1 font-weight-bold grey--text text--darken-3">{{ year_selected?.business_unit_description || '—' }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-md-1 pb-2 pb-md-0">
            <v-card class="rounded-lg pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar size="44" color="green lighten-5" class="mr-3">
                  <v-icon color="green darken-2">trending_up</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Monto apertura</div>
                  <div class="body-1 font-weight-bold grey--text text--darken-3">
                    {{ year_selected?.opened_diary_book?.currency_code }}${{ currencyFormat(year_selected?.opened_diary_book?.amounts || 0) }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="pl-md-2">
            <v-card class="rounded-lg pa-4" elevation="1">
              <div class="d-flex align-center">
                <v-avatar size="44" color="red lighten-5" class="mr-3">
                  <v-icon color="red darken-2">trending_down</v-icon>
                </v-avatar>
                <div>
                  <div class="caption grey--text text--darken-1">Monto cierre</div>
                  <div class="body-1 font-weight-bold grey--text text--darken-3">
                    {{ year_selected?.closed_diary_book?.currency_code }}${{ currencyFormat(year_selected?.closed_diary_book?.amounts || 0) }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Asientos: apertura y cierre -->
        <v-row no-gutters>
          <!-- Asiento de apertura -->
          <v-col cols="12" md="6" class="pr-md-2 pb-2 pb-md-0">
            <v-card class="rounded-lg" elevation="1" style="border-top: 4px solid #43A047">
              <v-card-title class="pb-1">
                <v-icon color="green darken-2" class="mr-2">play_circle_outline</v-icon>
                <span class="body-1 font-weight-bold green--text text--darken-2">Asiento de Apertura</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list dense class="pa-0">
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Número de asiento</v-list-item-subtitle>
                      <v-hover v-slot="{ hover }">
                        <span
                          v-if="year_selected?.opened_diary_book?.diary_book_code != null"
                          @click="show_entry(year_selected?.opened_diary_book_id)"
                          class="primary--text font-weight-medium body-2"
                          :class="{ 'text-decoration-underline': hover }"
                          style="cursor: pointer"
                        >
                          {{ year_selected?.opened_diary_book?.diary_book_code }}
                          <v-icon x-small color="primary" v-if="hover">open_in_new</v-icon>
                        </span>
                        <span v-else class="grey--text body-2">N/A</span>
                      </v-hover>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider inset></v-divider>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">attach_money</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Monto</v-list-item-subtitle>
                      <span class="font-weight-bold body-2">
                        {{ year_selected?.opened_diary_book?.currency_code }}${{ currencyFormat(year_selected?.opened_diary_book?.amounts || 0) }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider inset></v-divider>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">event</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Fecha contable</v-list-item-subtitle>
                      <span class="body-2">{{ year_selected?.opened_diary_book?.effective_date || 'N/A' }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Asiento de cierre -->
          <v-col cols="12" md="6" class="pl-md-2">
            <v-card class="rounded-lg" elevation="1" style="border-top: 4px solid #E53935">
              <v-card-title class="pb-1">
                <v-icon color="red darken-1" class="mr-2">stop_circle</v-icon>
                <span class="body-1 font-weight-bold red--text text--darken-1">Asiento de Cierre</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list dense class="pa-0">
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Número de asiento</v-list-item-subtitle>
                      <v-hover v-slot="{ hover }">
                        <span
                          v-if="year_selected?.closed_diary_book?.diary_book_code != null"
                          @click="show_entry(year_selected?.closed_diary_book_id)"
                          class="primary--text font-weight-medium body-2"
                          :class="{ 'text-decoration-underline': hover }"
                          style="cursor: pointer"
                        >
                          {{ year_selected?.closed_diary_book?.diary_book_code }}
                          <v-icon x-small color="primary" v-if="hover">open_in_new</v-icon>
                        </span>
                        <span v-else class="grey--text body-2">N/A</span>
                      </v-hover>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider inset></v-divider>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">attach_money</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Monto</v-list-item-subtitle>
                      <span class="font-weight-bold body-2">
                        {{ year_selected?.closed_diary_book?.currency_code }}${{ currencyFormat(year_selected?.closed_diary_book?.amounts || 0) }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider inset></v-divider>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="mr-3 my-auto">
                      <v-icon small color="grey">event</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Fecha contable</v-list-item-subtitle>
                      <span class="body-2">{{ year_selected?.closed_diary_book?.effective_date || 'N/A' }}</span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </div>
    </v-slide-x-transition>

    <!-- ══════════════════════ DIALOG: CERRAR AÑO ══════════════════════ -->
    <v-dialog v-model="show_dialog_confirm" max-width="460" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pa-0">
          <div style="background: linear-gradient(135deg,#1565C0,#0288D1); width:100%;" class="rounded-t-lg px-6 py-4">
            <div class="d-flex align-center">
              <v-icon color="white" class="mr-2">free_cancellation</v-icon>
              <span class="white--text text-h6 font-weight-bold">Cerrar año fiscal</span>
            </div>
            <div class="white--text body-2 mt-1" style="opacity:.8">Esta acción cerrará el ejercicio seleccionado.</div>
          </div>
        </v-card-title>
        <v-card-text class="pt-5 pb-2">
          <v-row no-gutters class="mb-4">
            <v-col>
              <v-alert dense text color="warning" icon="warning_amber" class="rounded-lg mb-0">
                ¿Seguro que desea cerrar el año <strong>{{ year_selected?.calendar }}</strong>?
              </v-alert>
            </v-col>
          </v-row>
          <v-autocomplete
            v-model="next_year"
            label="Año a abrir (siguiente ejercicio)"
            :items="calendar_to_open"
            color="primary"
            item-value="id"
            item-text="calendar"
            outlined dense hide-details
            prepend-inner-icon="calendar_today"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn text color="grey darken-1" @click="show_dialog_confirm=false" :disabled="loading_save">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="close_year()" :loading="loading_save">
            <v-icon left small>lock</v-icon> Confirmar cierre
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ══════════════════════ DIALOG: REABRIR AÑO ══════════════════════ -->
    <v-dialog v-model="show_dialog_reopen" max-width="420" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pa-0">
          <div style="background: linear-gradient(135deg,#E65100,#FF8F00); width:100%;" class="rounded-t-lg px-6 py-4">
            <div class="d-flex align-center">
              <v-icon color="white" class="mr-2">lock_open</v-icon>
              <span class="white--text text-h6 font-weight-bold">Reabrir año fiscal</span>
            </div>
            <div class="white--text body-2 mt-1" style="opacity:.8">Esta acción revertirá el cierre contable.</div>
          </div>
        </v-card-title>
        <v-card-text class="pt-5 pb-2">
          <v-alert dense text color="warning" icon="warning_amber" class="rounded-lg">
            ¿Seguro que desea reabrir el año <strong>{{ year_selected?.calendar }}</strong>? Se revertirá el cierre contable del ejercicio seleccionado.
          </v-alert>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn text color="grey darken-1" @click="show_dialog_reopen=false" :disabled="loading_save">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="orange darken-2" dark @click="reopen_year()" :loading="loading_save">
            <v-icon left small>lock_open</v-icon> Confirmar reapertura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import DialogConfirm from "@/components/DialogConfirm.vue";
import moment from "moment";
export default {
  data: () => ({
    loading: false,
    loading_save: false,
    show_dialog_confirm: false,
    show_dialog_reopen: false,
    show_details: false,
    search: null,
    next_year: null,
    business_unit_id: 123,
    headers: [
      { text: "ID", align: "start", value: "id", width: "70" },
      { text: "Calendario", align: "start", value: "calendar" },
      { text: "Desde", value: "date_from" },
      { text: "Hasta", value: "date_to" },
      { text: "Estado", value: "status" },
      { text: "", value: "options", sortable: false, width: "60" },
    ],
    items_calendar: [],
    year_selected: null,
  }),
  components: { DialogConfirm },
  mounted() {
    this.get_years();
  },
  computed: {
    calendar_to_open() {
      return this.items_calendar;
    },
  },
  methods: {
    async get_years() {
      try {
        this.loading = true;
        const response = await this.api_Post("accounting/get_year_closing", { business_unit_id: this.business_unit_id });
        if (response.status == 200) {
          this.items_calendar = await response.json();
        }
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message);
      }
      this.loading = false;
    },
    view_details(item) {
      this.year_selected = item;
      this.show_details = true;
    },
    show_entry(id) {
      const route = this.$router.resolve({ name: "ViewEntryDetail", params: { id } });
      window.open(route.href);
    },
    async close_year() {
      try {
        this.loading_save = true;
        const response = await this.api_Post("accounting/close_year", {
          p_business_unit_id: this.business_unit_id,
          p_from_accounting_calendar_id: this.year_selected.id,
          p_to_accounting_calendar_id: this.next_year,
          p_created_by: this.$store.state.auth.user.user.user_id,
        });
        if (response.status == 200) {
          this.$toast.success("Cierre realizado con éxito!");
          this.show_dialog_confirm = false;
          this.show_details = false;
          await this.get_years();
        }
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message);
      }
      this.loading_save = false;
    },
    async reopen_year() {
      try {
        this.loading_save = true;
        const response = await this.api_Post("accounting/reopen_year", {
          p_business_unit_id: this.business_unit_id,
          p_accounting_calendar_id: this.year_selected.id,
        });
        if (response.status == 200) {
          this.$toast.success("Año reabierto con éxito!");
          this.show_dialog_reopen = false;
          this.show_details = false;
          await this.get_years();
        }
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message);
      }
      this.loading_save = false;
    },
  },
};
</script>
